import type { MapHeatmapResponse } from '@repo/wemod-api-client/heatmap-api-client';
import type { HeatmapCategoryUiOption, HeatmapTitleConfig } from './heatmap-config';
import { getHeatmapCategoryOption } from './heatmap-config';
import type { HeatmapFeatureCollection } from './heatmap-types';

export interface HeatmapEventOption extends HeatmapCategoryUiOption {
    readonly eventType: string;
}

/** Sidebar category checkbox accent (matches other category color chips). */
export const HEATMAP_EVENTS_CATEGORY_COLOR = '#FF8A3D';

export function getHeatmapEventCount(
    source: HeatmapFeatureCollection | MapHeatmapResponse | null | undefined,
    eventType: string,
): number {
    if (!source) return 0;
    if ('meta' in source) {
        return source.meta.totals[eventType] ?? 0;
    }
    return source.event_categories[eventType]?.total_events ?? 0;
}

export function getHeatmapEventOptions(
    source: HeatmapFeatureCollection | MapHeatmapResponse | null | undefined,
    config: HeatmapTitleConfig | null | undefined,
): HeatmapEventOption[] {
    if (!source) return [];
    const eventTypes = 'meta' in source ? source.meta.event_types : Object.keys(source.event_categories);
    return eventTypes.map(eventType => {
        const option = getHeatmapCategoryOption(config, eventType);
        return {
            eventType,
            icon: option?.icon ?? 'category',
            color: option?.color ?? HEATMAP_EVENTS_CATEGORY_COLOR,
            iconColor: option?.iconColor,
        };
    });
}

export function getHeatmapEventOption(
    config: HeatmapTitleConfig | null | undefined,
    eventType: string,
): HeatmapEventOption {
    const option = getHeatmapCategoryOption(config, eventType);
    if (!option) {
        return {
            eventType,
            icon: 'category',
            color: HEATMAP_EVENTS_CATEGORY_COLOR,
        };
    }
    return { eventType, ...option };
}

/** CDN URL pattern for hotspot sample clip ids returned by the heatmap API. */
export function heatmapVideoUrl(videoId: string): string {
    return `https://media.wand.com/${videoId}.mp4`;
}
